<svelte:options runes={false} />

<script>
  // `APP_STYLE` §8: loading shows structure, not spinners — skeleton rows
  // matching the final layout. On the payer surface a spinner may never replace
  // the whole page, so each variant below is the shape of the route it stands
  // in for, not a generic block.
  //
  // The label is announced rather than drawn: a sighted reader gets the shape,
  // a screen-reader user gets the sentence.
  export let variant = 'page';
  export let label = 'Loading';
</script>

<section class="panel route-skeleton" class:payer-shell={variant === 'payer' || variant === 'payment'} aria-busy="true">
  <p class="visually-hidden" role="status">{label}</p>

  {#if variant === 'payer'}
    <!-- Ledger header: eyebrow, title, title block, model statement. -->
    <div class="skeleton-line skeleton-eyebrow" aria-hidden="true"></div>
    <div class="skeleton-line skeleton-title" aria-hidden="true"></div>
    <div class="skeleton-title-block" aria-hidden="true">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="skeleton-line" aria-hidden="true"></div>
    <div class="skeleton-line skeleton-short" aria-hidden="true"></div>
    <!-- The work list, which is what the payer reads first. -->
    <div class="skeleton-rows" aria-hidden="true">
      <div class="skeleton-row"></div>
      <div class="skeleton-row"></div>
      <div class="skeleton-row"></div>
    </div>
  {:else if variant === 'payment'}
    <div class="skeleton-line skeleton-eyebrow" aria-hidden="true"></div>
    <div class="skeleton-line skeleton-title" aria-hidden="true"></div>
    <div class="skeleton-line" aria-hidden="true"></div>
    <div class="skeleton-rows" aria-hidden="true">
      <div class="skeleton-row skeleton-stat"></div>
      <div class="skeleton-row skeleton-stat"></div>
      <div class="skeleton-row skeleton-stat"></div>
    </div>
  {:else if variant === 'operator'}
    <div class="skeleton-line skeleton-eyebrow" aria-hidden="true"></div>
    <div class="skeleton-rows" aria-hidden="true">
      <div class="skeleton-row skeleton-stat"></div>
      <div class="skeleton-row skeleton-stat"></div>
      <div class="skeleton-row skeleton-stat"></div>
      <div class="skeleton-row skeleton-stat"></div>
    </div>
  {:else}
    <div class="skeleton-line skeleton-title" aria-hidden="true"></div>
    <div class="skeleton-line" aria-hidden="true"></div>
    <div class="skeleton-line skeleton-short" aria-hidden="true"></div>
  {/if}
</section>
